import { DatePickerProps as AntdDatePickerProps } from 'antd';
import { Dayjs } from 'dayjs';
import { GlobalStyles, StyledDatePicker } from './DatePickerStyles';
import { CalendarIcon } from '@/icons';

export type IDatePickerProps = AntdDatePickerProps<Dayjs>;

const DatePicker = ({ needConfirm = false, ...props }: IDatePickerProps): JSX.Element => (
  <>
    <StyledDatePicker suffixIcon={<CalendarIcon />} needConfirm={needConfirm} {...props} />
    <GlobalStyles />
  </>
);

export default DatePicker;
